import React, { Component } from "react";
import DragSortableList from "../../../../../CC_cubi_clan_project/GlobalComponents/DragSortableList/DragSortableList";
import { toDataUrl, getStableKey, resolveParentIndex } from "../../../../../CC_cubi_clan_project/GlobalComponents/DragSortableList/dndUtils";
import { mfmFramedUrl } from "../../../../../CC_cubi_clan_project/Utils/MfmService";
import "./CommentsSection.css";

const WIDE_FORMAT_KEY = "ratio:16:9";

/**
 * Props:
 *  - comments: [
 *      { idComentario?, authorName, origin, imageBase64, text, link, date, sortOrder? }
 *    ]
 *  - onEdit(index, item)       // índice REAL del array en el padre
 *  - onCreate()
 *  - onChange(updatedArray)    // DragSortableList entrega array reindexado (sortOrder = i+1)
 */

// Extractor de ID prioritario para comentarios
const commentId = (c) => c?.idComentario;
// Fallback para nuevos sin ID
const fallback = (a, b) =>
  !a?.idComentario && (a?.text || "") === (b?.text || "") && (a?.authorName || "") === (b?.authorName || "");

export default class CommentsSection extends Component {
  static defaultProps = { comments: [] };

  handleReorder = (updated) => {
    this.props.onChange && this.props.onChange(updated);
  };

  handleEditClick = (visibleIndex, comment) => {
    const parentArr = this.props.comments || [];
    const realIndex = resolveParentIndex(parentArr, comment, [commentId], fallback);
    const indexForParent = realIndex >= 0 ? realIndex : visibleIndex;
    this.props.onEdit && this.props.onEdit(indexForParent, comment);
  };

  renderItem = (comment, idx, { over }) => {
    const img = comment?.imageUuid
      ? mfmFramedUrl(comment.imageUuid, 320, 180, WIDE_FORMAT_KEY)
      : toDataUrl(comment?.imageBase64);

    return (
      <div
        className={`cs-card ${over ? "is-over" : ""}`}
        onClick={() => this.handleEditClick(idx, comment)}
        title={`Orden ${comment?.sortOrder || idx + 1}`}
      >
        {/* Imagen (si existe) */}
        {img ? (
          <div className="cs-thumb">
            <img src={img} alt={comment?.authorName || "Comentario"} />
          </div>
        ) : null}

        {/* Cuerpo */}
        <div className="cs-body">
          {comment?.text && (
            <p className="cs-text">"{comment.text}"</p>
          )}
          {comment?.authorName && (
            <div className="cs-author">{comment.authorName}</div>
          )}
          {comment?.origin && (
            <div className="cs-origin">{comment.origin}</div>
          )}
          {comment?.date && (
            <div className="cs-date"><i className="fas fa-calendar-alt me-1" />{comment.date}</div>
          )}
          <span className="cs-edit-label">Editar</span>
        </div>
      </div>
    );
  };

  render() {
    const { comments, onCreate } = this.props;

    return (
      <section className="comments-section">
        <h3 className="project-subtitle">Comentarios y recortes</h3>

        <DragSortableList
          items={comments}
          orderProp="sortOrder"
          onChange={this.handleReorder}
          getKey={(item, idx) => getStableKey(item, idx, [commentId])}
          renderItem={this.renderItem}
        />

        {/* Botón añadir (fuera del grid DnD, no arrastrable) */}
        <div className="comments-add-tile" onClick={() => onCreate && onCreate()}>
          <span className="comments-add-plus">＋</span>
          <span>Añadir comentario</span>
        </div>
      </section>
    );
  }
}
